var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.navItems),function(item,i){return [_c('NavItem',{key:i,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }